<form [formGroup]="documentoPersonaFormGroup">
  <div class="row">
    <mat-form-field class="col-xs-12">
      <mat-label>País de documento:</mat-label>
      <mat-select formControlName="pais_codigo" (selectionChange)="onChangePais($event)" required
        [disabled]="camposLectura()">
        <mat-option *ngFor="let pais of documentoPersonaSet.paises" [value]="pais.codigo">
          {{pais.nombre}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="documentoPersonaFormGroup.get('pais_codigo')?.hasError('required')">
        Debe ingresar país
      </mat-error>
    </mat-form-field>
  </div>
  <div class="row" *ngIf="tiposDocumentosFiltrado">
    <mat-form-field class="col-xs-6 col-sm-12">
      <mat-label>Tipo de documento:</mat-label>
      <mat-select formControlName="tipo_documento_codigo" required [disabled]="camposLectura()">
        <mat-option *ngFor="let tipoDocumento of tiposDocumentosFiltrado" [value]="tipoDocumento.codigo">
          {{tipoDocumento.nombre}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="documentoPersonaFormGroup.get('tipo_documento_codigo')?.hasError('required')">
        Debe ingresar tipo documento
      </mat-error>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="col-xs-6 col-sm-12">
      <input matInput placeholder="Número:" formControlName="numero" required [readonly]="camposLectura()">
      <mat-error *ngIf="documentoPersonaFormGroup.get('numero')?.hasError('required')">
        Debe ingresar número
      </mat-error>
    </mat-form-field>
  </div>
</form>